<template>
    <div>
        <Nav></Nav>
        <b-container>
            <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>
            <TipsAlert text="緣分只是一個摸不著的東西，而在中國古代，大家更是相信緣分天定的說法。今天小桃就來告訴大家一種緣分配對法，看看你和誰會是天賜良緣吧！"></TipsAlert>

            <FormCompareBox ref="modalmain" v-on:sendAction="MainData" :subtitle="'主要對象'" class="mb-2" :familiarFnu="false"></FormCompareBox>
            <FormCompareBox ref="modalsec" v-on:sendAction="SecData" :subtitle="'比對對象'" class="mb-2" :familiarFnu="false"></FormCompareBox>
            <b-button pill block variant="primary" size="lg" class="text-white shadow-lg my-3" style=" background: linear-gradient(180deg, rgba(215,176,128,1) 0%, rgba(164,120,85,1) 100%)" @click="callaction">進行比對</b-button>
        </b-container>
        <PaymentModel :product="productName" :point="Price" v-on:sendAction="GoPayment"></PaymentModel>
        <AnaLoading way="" :show="pageloading"></AnaLoading>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import TipsAlert from '@/components/TipsAlert.vue'
import PageHeader from '@/components/PageHeader.vue'
import FormCompareBox from '@/components/FormCompareBox.vue'
import PaymentModel from '@/components/PaymentModel.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {alertModel} from '@/service/commuse'

export default {
  name: 'Client',
  components: {Nav,PageHeader,TipsAlert,FormCompareBox, PaymentModel,AnaLoading},
  data () {
    return {
      productName:'情侶雙方比對',
      mainformData: {},
      secformData: {},
      pageloading:false,
      puid:'6'
    }
  },
  computed:{
    ...mapState(['productdata']),
    Price:function () {return this.productdata.data.find(x => x.id === this.puid).price},
  },
  methods: {
    callaction () {
      this.$refs.modalmain.toggleModal()
      this.$refs.modalsec.toggleModal()
      if(Object.keys(this.mainformData).length !== 0 && Object.keys(this.secformData).length !== 0){
        this.PaymentPopup()
      }
    },
    MainData(data){

      this.mainformData = data
    },
    SecData(data){

      this.secformData = data
    },
    PaymentPopup () {
      this.$store.dispatch('actionGetCurencyPlan', {})
        .then((res) => {
          if(res.data.point == 9999999){
            this.GoPayment()
          }else{
            this.$bvModal.show('PaymentModel')
          }
        }).catch((res) => {
        this.$bvModal.show('PaymentModel')
      });
    },
    GoPayment () {
      this.pageloading = true
      this.$store.dispatch('actionAnaResult', {
        mainname: this.mainformData.name,
        maintype: this.mainformData.type,
        mainsex: this.mainformData.sex,
        secname: this.secformData.name,
        sectype: this.secformData.type,
        secsex: this.secformData.sex,
        producttype:'Love'
      }).then((res) => {
        this.$store.dispatch('actionGetPoint', {}).then((res) => {
          setTimeout(()=>{
            this.$router.push('/LoverResult');
            this.pageloading = false
          },1500)
        })

      }).catch((res) => {
        alertModel(this,'系統訊息','點數餘額不足')
      });
    }

  }
}
</script>

<style scoped>

</style>
